import {StatsStrategy} from "../statsStrategy";
import React from "react";
import {UserWithStats} from "../../UserWithStats";
import {TFunction} from "i18next";
import {StatDetailsIcon, StatIconType} from "../../../components/stats/userStats/statDetailsIcon";
import {getRelativeTime} from "../../../utils";
import {UiFlag} from "../../../components/ui-components/flag/UiFlag";
import {Graph} from "../../../components/stats/userStats/graphBestScore/graph";


export class StatsStrategyRace extends StatsStrategy {
    leftPart(t: TFunction<"translation", undefined>, playerStats: UserWithStats): React.ReactNode {
        if (playerStats === null) return <></>;

        const translateString = getRelativeTime(t, playerStats.dateBest)

        return <>
            <div className="flex gap-5">
                <div>
                    <p>{t("stats.global-ranking")}</p>
                    <div className="flex h-6 items-center">
                        <p>{`#${playerStats.globalRank}`}</p>
                    </div>
                </div>

                <div>
                    <p>{t("stats.country-ranking")}</p>
                    <div className="flex justify-between items-center">
                        <p>{`#${playerStats.countryRank}`}</p>
                        {playerStats.country &&
                            <UiFlag className="w-10 h-6" countryCode={playerStats.country}/>}

                    </div>
                </div>
            </div>

            {playerStats.bestScoresByDay !== undefined && <div className="h-44">
                <div>
                    <p>{t("stats.graph-of-best-scores")}</p>
                    <p className="text-white-transparent">{t("stats.best-score") + ": " + translateString}</p>
                </div>

                <Graph
                    key={JSON.stringify(playerStats.bestScoresByDay)}
                    data={playerStats.bestScoresByDay}
                    label={t("global.seconds")}
                    reverseY={true}
                />
            </div>}
        </>;
    }

    rightPart(t: TFunction<"translation", undefined>, playerStats: UserWithStats): React.ReactNode {
        return <>
            <StatDetailsIcon icon={StatIconType.BEST_SCORE_SECONDS} data={playerStats.best}/>
            <StatDetailsIcon icon={StatIconType.MEAN_SECONDS} data={playerStats.mean}/>
            {playerStats.totalGames !== undefined &&
                <StatDetailsIcon icon={StatIconType.GAMES_PLAYED} data={playerStats.totalGames}/>}
            {playerStats.totalWords !== undefined &&
                <StatDetailsIcon icon={StatIconType.WORDS_TYPED} data={playerStats.totalWords}/>}
            <StatDetailsIcon icon={StatIconType.ACCURACY} data={playerStats.accuracy}/>
        </>;
    }
}
